{
  "chart.area": "Område",
  "chart.bar": "Stolpe",
  "chart.pie": "Kake",
  "chart.radar": "Radar",
  "chartChooser.chooseChart": "Velg graf",
  "chartChooser.missingData": "Mangler data for graf.",
  "chartChooser.noSelect": "Ingen graf valgt.",
  "chartChooser.unavailable": "Graftype utilgjengelig.",
  "numberOf": "Antall"
}
